import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import NavbarIconsInnovation from "../generic-nav-bar/NavbarIconsInnovation";
import useFormValidations from "../../app/hooks/useFormValidations";
import { useHydrateViewCatalogRelations } from "../../app/hooks/useHydrateViewCatalogRelations";
import { Link } from "react-router-dom";
import { startLoadingCatalogCiiusAll } from "../../app/actions/catalogCiiuActions";
import { startLoadingCatalogSectionsAll } from "../../app/actions/catalogSectionActions";
import { startLoadingCatalogPhasesAll } from "../../app/actions/catalogPhaseActions";
import { startLoadingContinents } from "../../app/actions/continentActions";
import { startLoadingRegions } from "../../app/actions/regionActions";
import { startLoadingCountries } from "../../app/actions/countryActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import IntegrationViewChrome from "../end-user-search/IntegrationViewChrome";
import { useIntegrationNestedPreview } from "../end-user-search/integrationNestedPreviewContext";
import DetailSectionsLayout from "../end-user-search/DetailSectionsLayout";
import { getSectionHeader } from "../../app/helpers/helperValidationViewPreview";

const PreviewInnovation = () => {
  debugLogPages(':: PreviewInnovation');

  const dispatch = useDispatch();
  const { nested, setDetailMode } = useIntegrationNestedPreview();

  const { t } = useTranslation();

  /********Store*******/
  const { innovationSelected } = useSelector((state) => state.innovation);

  const { listFieldsInnovationView, listFieldsInnovationPreview } = useSelector((state) => state.moduleConfig);

  /********UseForm*******/
  const { values, setValues } = useFormValidations(
    () => InnovationCallback(),
    innovationSelected,
    listFieldsInnovationView
  );

  const InnovationCallback = () => {
    
  };

  useHydrateViewCatalogRelations('Innovation', values, setValues);

  useEffect(() => {
    /*JT Load Please */
    dispatch(startLoadingCatalogCiiusAll());
    dispatch(startLoadingCatalogSectionsAll());
    dispatch(startLoadingCatalogPhasesAll());

    dispatch(startLoadingContinents());
    dispatch(startLoadingRegions());
    dispatch(startLoadingCountries());

  }, [])

  const { arrayListPrincipal, arrayListSecondary } = listFieldsInnovationPreview;

  const innovationViewRelations = {
    multimedia: "ModuleFile_To_Innovation",
    problems: "ModuleProblem_To_Innovation"
  };

  const sharedViewProps = {
    values,
    t,
    ProblemTableComponent: null, // 💡 Pasamos null aquí también
    relationKeys: innovationViewRelations,
    isPreviewMode: true 
  };

          const principalHeader = getSectionHeader(arrayListPrincipal);
          const secondaryHeader = getSectionHeader(arrayListSecondary);

  const onGoFullVersion = (e) => {
    if (!nested || !setDetailMode) return;
    e.preventDefault();
    setDetailMode('view');
  };

  return (
    <div>
      {!nested && <NavbarIconsInnovation page={"viewText"} />}

      {!nested && (
        <IntegrationViewChrome
          sourceModuleKey="innovation"
          record={innovationSelected}
        />
      )}

      <div className="d-flex justify-content-center page-title">{t("innovation.preview.title")}</div>
      <hr className="line-hr" />
      <div className="section is-fullheight">
        <div className="container">
          <form>
            <div className="container-fluid">
              <div className="text-center fw-bolder">
                <div className="text-center">
                  {nested ? (
                    <button
                      type="button"
                      className="btn btn-link p-0 fw-bolder"
                      onClick={onGoFullVersion}
                    >
                      {t("innovation.preview.redirect")}
                    </button>
                  ) : (
                    <Link to="/end-user-search/view-innovation">
                      {t("innovation.preview.redirect")}
                    </Link>
                  )}
                </div>
              </div>

              <DetailSectionsLayout
                nested={nested}
                isPreviewMode
                arrayListPrincipal={arrayListPrincipal}
                arrayListSecondary={arrayListSecondary}
                principalHeader={principalHeader}
                secondaryHeader={secondaryHeader}
                sharedViewProps={sharedViewProps}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PreviewInnovation;
